<template>
  <q-expansion-item class="access-products-item">
    <template v-slot:header>
      <strong
        >App roles
        <sup
          ><q-icon name="info" size="14px" class="q-ml-xs"
            ><q-tooltip style="width: 400px"
              >Some Infrastructure Services provide App Roles available to order by APIMGMT consumers. List might be
              empty for selected Infrastructure Service.</q-tooltip
            ></q-icon
          ></sup
        >
      </strong>
    </template>
    <div v-if="loadAccessProducts" class="flex items-center justify-center q-py-lg" style="padding: 30px 0">
      <q-spinner-gears size="40px" color="primary"></q-spinner-gears>
    </div>
    <div class="actions-table-holder q-mt-md" v-else-if="virtualApis.length">
      <q-table :columns="virtualApisColumns" :rows="virtualApiData" class="table-info access-products-table" flat>
        <template v-slot:no-data>
          <div class="flex full-width column items-center q-py-lg">
            <q-icon name="hide_source" class="q-mb-sm" size="60px" color="primary"></q-icon>
            <span class="block" style="font-size: 14px">No records.</span>
          </div>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td v-for="col in props.cols" :key="col.name" :props="props">
              <div v-if="col.name === 'actions'" class="flex items-center justify-end">
                <q-btn
                  flat
                  round
                  size="12px"
                  style="width: 30px; height: 40px"
                  class="btn--no-hover"
                  :icon="expandedVirtualApis.includes(props.row.id) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                  @click="toggleRow(props.row.id)"
                />
              </div>
              <div v-else>
                {{ props.row[col.name] }}
              </div>
            </q-td>
          </q-tr>
          <q-tr v-show="expandedVirtualApis.includes(props.row.id)" :props="props">
            <q-td
              colspan="100%"
              style="background-color: rgba(247, 247, 247); padding: 5px 5px 5px 15px"
              class="q-pa-none"
            >
              <q-table
                :rows="props.row.roles"
                :columns="rolesColumns"
                class="table-api"
                row-key="name"
                hide-bottom
                flat
                dense
                separator="none"
              >
                <template v-slot:header></template>
                <template v-slot:body-cell-env="cellProps">
                  <q-td :props="cellProps" class="flex items-center q-pl-xl">
                    <b>{{ cellProps.row.name }}</b>
                    <q-icon
                      :name="isAccessProductExists(cellProps.row.status) ? 'check_circle' : 'block'"
                      :color="isAccessProductExists(cellProps.row.status) ? 'blue-5' : 'grey-5'"
                      class="q-ml-md q-mr-xs"
                      size="18px"
                      ><q-tooltip>{{ cellProps.row.status }}</q-tooltip></q-icon
                    >
                    {{ props.row.env }}
                  </q-td>
                </template>
              </q-table>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <div v-else class="flex full-width column items-center q-py-lg" style="padding: 30px 0">
      <q-icon name="hide_source" class="q-mb-sm" size="40px" color="primary"></q-icon>
      <span class="block" style="font-size: 16px">No data</span>
    </div>
  </q-expansion-item>
</template>

<script>
export default {
  name: 'AccessProductsTable',
  props: {
    virtualApis: {
      type: Array,
    },
    loadAccessProducts: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      virtualApisColumns: [
        {
          label: 'Virtual API provider ID',
          name: 'id',
          field: 'id',
          align: 'left',
        },
        {
          label: 'Roles',
          name: 'actions',
          field: 'actions',
          align: 'right',
        },
      ],
      rolesColumns: [
        {
          label: '',
          name: 'env',
          field: 'env',
          align: 'left',
        },
      ],
      expandedVirtualApis: [],
    };
  },
  computed: {
    virtualApiData() {
      return this.virtualApis.map((api) => ({
        id: api.id,
        roles: api.azureRoles,
        env: api._environmentId,
      }));
    },
  },
  watch: {
    virtualApis: {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.expandedVirtualApis = newVal.map((api) => api.id);
        }
      },
      immediate: true,
    },
  },
  methods: {
    isAccessProductExists(status) {
      return status === 'exists';
    },
    toggleRow(rowKey) {
      const index = this.expandedVirtualApis.indexOf(rowKey);
      if (index > -1) {
        this.expandedVirtualApis.splice(index, 1);
      } else {
        this.expandedVirtualApis.push(rowKey);
      }
    },
  },
};
</script>

<style lang="sass">
.access-products-table
  tbody td::before
    display: none !important
  max-height: 380px
  thead tr
    height: 35px !important
  thead tr:first-child th
    background-color: #edeff5
  thead tr th
    position: sticky
    z-index: 1
    border-bottom-width: 0 !important
  thead tr:first-child th
    top: 0
  &.q-table--loading thead tr:last-child th
    top: 48px
</style>

<style lang="sass">
.table-api
  thead tr
    height: 30px !important
  thead tr:first-child th
    background: rgba(247,247,247) !important
  tbody tr
    background: rgba(247,247,247)
</style>
